<template>
  <div class="proDetail" style="margin-top: 130px;">
    <!-- <div class="prodetail_header">
    </div> -->
    <div class="product_info">
      <!-- 产品图片 -->
      <div class="product-image-container">

        <!-- <div class="image-loading" v-if="isLoadingImage">
          <div class="spinner"></div>
        </div> -->


        <!-- 产品名称和型号 -->
        <div class="product-basic-info">
          <!-- <el-tabs type="border-card">
            <el-tab-pane label="产品详情"> -->
          <div>
            <h1 class="product-name">{{ product.type }}加工中心</h1>
            <div class="product-type">{{ product.name }}</div>
            <div class="Pline"></div>
            <!-- <div v-html="convertLinksToImages(product.content)" style="text-align: center;" class="content_cotainer"
              @click="handleImageClick">
            </div> -->
            <!-- <button class="back-btn" @click="goBack">
              <i class="fas fa-arrow-left"></i> 返回列表
            </button> -->

          </div>
          <!-- </el-tab-pane> -->
          <!-- <el-tab-pane label="技术参数"> -->
          <div class="content-container">
            <div v-html="convertLinksToImages(product.content)" style="text-align: center;" class="content_cotainer"
              @click="handleImageClick">
            </div>
            <div style="width: 100%;text-align: center;">
              <!-- <img :src="product.aiurl" alt="" @click="openPreview(product.aiurl)"> -->
              <el-image :src="$i18n.locale === 'en' ? product.url : product.aiurl" alt=""
                :preview-src-list="[product.aiurl]" style="width: 100%;">
              </el-image>
              <button class="back-btn" @click="goBack">
                <i class="fas fa-arrow-left"></i> 返回列表
              </button>
            </div>

          </div>
          <!-- </el-tab-pane>
          </el-tabs> -->

        </div>
      </div>


    </div>
    <div class="image-preview-modal" v-if="isPreviewOpen" @click="closePreview">
      <div class="preview-content" @click.stop>
        <button class="close-btn" @click="closePreview">×</button>
        <img :src="currentPreviewImage" alt="预览图片" class="preview-image"
          :style="{ maxHeight: `${maxPreviewHeight}px`, transform: `scale(${scale})`, transition: 'transform 0.2s ease' }">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "frProjectDetail",
  data() {
    return {
      product: {
        name: '',
        type: '',
        viewpic: '',
        content: '',
        aiurl: '',
      },
      isLoadingImage: true,
      isLoadingContent: true,
      hasError: false,
      processedContent: '',
      isPreviewOpen: false,
      currentPreviewImage: '',
      maxPreviewHeight: 0,
      scale: 1, // 缩放比例，初始为1（100%）
      minScale: 0.5, // 最小缩放比例
      maxScale: 3 // 最大缩放比例
    };
  },
  created() {
    // 获取路由参数
    this.product = this.$route.params;
    console.log('产品数据', this.product);
    // 处理富文本内容
    this.processedContent = this.convertLinksToImages(this.product.content);

    // 计算最大预览高度（窗口高度的80%）
    this.maxPreviewHeight = window.innerHeight * 0.8;

    // 监听窗口大小变化，更新最大预览高度
    window.addEventListener('resize', this.handleResize);

    // 模拟内容加载延迟
    // setTimeout(() => {
    //   this.isLoadingContent = false;
    // }, 800);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.maxPreviewHeight = window.innerHeight * 0.8;
    },
    // 处理富文本区域的点击事件（事件委托）
    handleImageClick(e) {
      if (e.target.tagName.toLowerCase() === 'img') {
        e.preventDefault(); // 阻止默认行为（如富文本中的图片可能有默认跳转）
        // 调用预览图片的方法，传入当前图片的src
        this.openPreview(e.target.src);
      }
    },
    // 打开图片预览
    openPreview(imageUrl) {
      this.currentPreviewImage = imageUrl;
      this.isPreviewOpen = true;
      this.scale = 1;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
      document.addEventListener('wheel', this.handleWheel);
    },
    // 关闭图片预览
    closePreview() {
      this.isPreviewOpen = false;
      this.currentPreviewImage = '';
      // 恢复页面滚动
      document.body.style.overflow = '';
      document.removeEventListener('wheel', this.handleWheel);
    },
    isImageUrl(url) {
      const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
      return imageExtensions.test(url);
    },
    // 处理鼠标滚轮事件
    handleWheel(e) {
      e.preventDefault(); // 阻止事件冒泡和默认行为

      // 判断滚轮方向：deltaY为正向下滚（缩小），为负向上滚（放大）
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      let newScale = this.scale + delta;

      // 限制缩放范围在minScale和maxScale之间
      newScale = Math.max(this.minScale, Math.min(newScale, this.maxScale));

      // 更新缩放比例
      this.scale = newScale;
    },

    convertLinksToImages(html) {
      // 正则表达式匹配a标签并提取href属性
      const regex = /<a[^>]+href="([^"]+)"[^>]*>(.*?)<\/a>/gi;

      // 替换为img标签，保留原链接作为图片路径
      return html.replace(regex, (match, href, text) => {
        // 可以添加图片格式判断，确保只有图片链接才被替换
        if (this.isImageUrl(href)) {
          return `<img src="${href}" alt="图片内容" class="max-w-full h-auto mx-auto" />`;
        }
        // 不是图片链接则保留原a标签
        return match;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    imageLoaded() {
      // 图片加载完成后隐藏加载状态
      this.isLoadingImage = false;
    },
    reloadContent() {
      this.hasError = false;
      this.isLoadingContent = true;

      // 模拟重新加载
      setTimeout(() => {
        this.isLoadingContent = false;
      }, 800);
    }
  },
  watch: {
    '$route.params'(newParams) {
      // 监听路由参数变化，更新产品信息
      this.product = newParams;
      this.isLoadingImage = true;
      this.isLoadingContent = true;
      // 重新处理富文本内容
      this.processedContent = this.convertLinksToImages(this.product.content);
      setTimeout(() => {
        this.isLoadingContent = false;
      }, 800);
    }
  }
};
</script>

<style lang="scss" scoped>
.Pline {
  height: 5px;
  width: 40px;
  background-color: #227818;
}

.content_cotainer {
  // height: 100px;
  display: flex;
  // flex-direction: column;
  flex-direction: row;
  // justify-content: space-between;
  height: 100%;
  padding-bottom: 20px;
  justify-content: center;
}

::v-deep .el-tabs--border-card {
  width: 100%;
}

::v-deep .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

::v-deep .is-active {
  background-color: #227818 !important;
  color: #fff !important;
}

::v-deep .el-tabs__item:not(.is-disabled):hover {
  color: #227818 !important
}

::v-deep .content_cotainer p {
  display: flex;
  flex-direction: row;
  // justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
}

::v-deep .content_cotainer img {
  // max-width: 100% !important;
  /* 强制最大宽度100%，防止溢出 */
  // height: auto !important;
  // height: 400px !important;
  height: auto !important;
  width: 50% !important;
  /* 保持宽高比 */
  display: block;
  /* 块状显示，方便居中 */
  // margin: 0 auto 16px;
  /* 上下间距+水平居中 */
  border-radius: 4px;
  // margin-right: 20px;
  /* 可选：圆角 */
}


.back-btn {
  background-color: #f0f0f0;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  margin-top: 100px;

  &:hover {
    background-color: #37B789;
    color: white;
    transform: translateX(-3px);
  }

  i {
    margin-right: 6px;
  }
}

// 基础样式
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

// 导航栏样式
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;

  .back-btn {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-back::before {
    content: '←';
    font-weight: bold;
  }

  .nav-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
}

// 主容器样式
.proDetail {
  width: 100%;
  padding-top: 50px; // 为导航栏留出空间
  background-color: #F2F2F2;
  padding: 0 20vw;
}

// 您指定的头部样式
// .prodetail_header {
//   width: 100%;
//   height: 520px;
//   background: url(../assets/furuiImg/probanner.webp);
//   background-size: cover;
//   background-position: center;
//   background-repeat: no-repeat;

//   .ph_box {
//     width: 80vw;
//     height: 520px;
//     margin: 0 auto;
//   }
// }

// 产品信息容器 - 所有内容都在这里面
.product_info {
  width: 100%;
  padding: 30px 0;
  background-color: #fff;
}

// 产品图片样式
.product-image-container {
  // width: 100vw;
  margin: 0 auto 30px;
  // border-radius: 10px;
  overflow: hidden;
  // background-color: #f0f0f0;
  // position: relative;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: row;
}

.product-image {
  width: 40vw;
  height: auto;
  object-fit: contain;
  display: block;
  // transition: opacity 0.5s ease-in-out;
  // opacity: 0;

  // &.loaded {
  //   opacity: 1;
  // }
}

// 图片加载动画
.image-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
}

// 产品基本信息样式
.product-basic-info {
  width: 100vw;
  // margin: 0 auto 40px;
  padding: 2vw;
  background-color: white;
  border-radius: 10px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  animation: fadeInUp 0.5s ease-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.3;
}

.product-type {
  font-size: 18px;
  font-weight: bold;
  color: #227818;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

// 产品内容样式
.product-content {
  width: 100%;
  padding: 0 0 40px;
}

.content-container {
  padding: 0 1vw;
  display: flex;
  flex-direction: column;
  // margin-top: 100px;
  text-align: right;
  // width: 80vw;
  // margin: 0 auto;
  line-height: 1.8;
  color: #333;
  // animation: fadeIn 0.8s ease-out;
  // width: 200px;
  width: 100%;
  justify-content: center;

  // 富文本内部图片样式
  img {
    width: 100%;
    // max-width: 100%;
    height: auto;
    // margin: 20px 0;
    border-radius: 8px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  // 富文本内部标题样式
  h2,
  h3 {
    margin: 25px 0 15px;
    color: #222;
    font-weight: 600;
  }

  // 富文本内部段落样式
  p {
    margin-bottom: 20px;
    font-size: 16px;
  }

  // 产品参数样式
  .parameters {
    width: 100%;
    border-collapse: collapse;
    margin: 25px 0;

    th,
    td {
      border: 1px solid #eee;
      padding: 12px 15px;
      text-align: left;
    }

    th {
      background-color: #f9f9f9;
      font-weight: 600;
      width: 30%;
    }
  }
}

// 内容加载状态
.content-loading {
  width: 100%;
  padding: 80px 0;
  text-align: center;

  p {
    margin-top: 15px;
    color: #666;
    font-size: 16px;
  }
}

// 错误状态
.content-error {
  width: 100%;
  padding: 80px 20px;
  text-align: center;

  p {
    color: #e53935;
    margin-bottom: 20px;
    font-size: 16px;
  }

  button {
    padding: 10px 20px;
    background-color: #37B789;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;

    &:hover {
      background-color: #2d9d72;
    }
  }
}

// 加载动画
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(55, 183, 137, 0.2);
  border-left-color: #37B789;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .ph_box {
    height: 270px !important;
  }

  .prodetail_header {
    height: 270px !important;
  }

  .product-name {
    font-size: 24px;
  }

  .content-container {
    font-size: 14px;

    h2 {
      font-size: 18px;
    }

    h3 {
      font-size: 16px;
    }

    .parameters {

      th,
      td {
        padding: 8px 10px;
        font-size: 14px;
      }
    }
  }
}

// 动画效果
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
<style lang="scss">
// 图片预览弹窗样式
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

.preview-content {
  position: relative;
  max-width: 100%;
}

.preview-image {
  max-width: 100%;
  object-fit: contain;
  cursor: zoom-in;
  transition: transform 0.3s ease;
}

// 关闭按钮样式
.close-btn {
  position: absolute;
  top: -40px;
  right: -40px;
  background: none;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
}

// 淡入动画
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>